module.exports = __webpack_public_path__ + "img/fabris.04fc3f94.webp";